import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const RequestEdit = Loadable({
  loader: () => import('./containers/RequestEditContainer'),
  loading: Loading,
})

export default {
  path: '/request/edit',
  component: RequestEdit,
}



// WEBPACK FOOTER //
// ./src/routes/requestEdit/index.js